var BaseModelFactory = (function () {
    function BaseModelFactory() {
    }
    BaseModelFactory.registrateType = function (key, type) {
        BaseModelFactory.typesDictionary[key] = type;
    };
    BaseModelFactory.getType = function (key) {
        return BaseModelFactory.typesDictionary[key];
    };
    BaseModelFactory.prototype.getModelCtor = function (mapperId) {
        return BaseModelFactory.getType(mapperId);
    };
    BaseModelFactory.typesDictionary = {};
    return BaseModelFactory;
}());
export { BaseModelFactory };
